import type { Consultant } from '../types/content';

export const CONSULTANT_DRAFT_NOTICE =
  'Draft profile. Portrait, biography and specialisms are placeholders pending approval by the consultant.';

export const consultants: Consultant[] = [
  {
    slug: 'moshood-a',
    name: 'Moshood A.',
    title: 'Executive Search Consultant',
    initials: 'MA',
    focus: 'C-suite and board appointments',
    specializations: ['C-Suite & Leadership Recruitment', 'Board & Non-Executive Director Search', 'Confidential & Retained Search'],
    industries: ['Financial Services & Banking', 'Energy & Utilities'],
    bio: [
      'Moshood partners with boards and chief executives on senior leadership appointments, with a particular focus on confidential searches.',
      'This biography is a draft placeholder and will be replaced with approved information.',
    ],
    approach: 'Begins every search with candid stakeholder conversations to agree what success will look like before any outreach starts.',
  },
  {
    slug: 'samuel-a',
    name: 'Samuel A.',
    title: 'Executive Search Consultant',
    initials: 'SA',
    focus: 'Technology and transformation leadership',
    specializations: ['Executive Search', 'Talent Mapping & Market Intelligence', 'Interim & Contract Recruitment'],
    industries: ['Technology & Digital Transformation', 'Telecommunications & Media'],
    bio: [
      'Samuel works with organisations appointing technology, digital and transformation leaders.',
      'This biography is a draft placeholder and will be replaced with approved information.',
    ],
    approach: 'Uses structured market mapping to give clients a clear view of the talent landscape early in every search.',
  },
  {
    slug: 'michael-i',
    name: 'Michael I.',
    title: 'Executive Search Consultant',
    initials: 'MI',
    focus: 'Operations, infrastructure and industrial leadership',
    specializations: ['Senior Management Recruitment', 'Permanent Recruitment', 'Strategic Talent Advisory'],
    industries: ['Manufacturing & Industrial Operations', 'Infrastructure & Transportation'],
    bio: [
      'Michael supports organisations appointing operational and senior management leaders.',
      'This biography is a draft placeholder and will be replaced with approved information.',
    ],
    approach: 'Focuses on practical, competency-based assessment and close communication with candidates throughout.',
  },
  {
    slug: 'anne-precious',
    name: 'Anne Precious',
    title: 'Executive Search Consultant',
    initials: 'AP',
    focus: 'Healthcare, legal and specialist professional search',
    specializations: ['Specialist Professional Search', 'Board & Non-Executive Director Search', 'Executive Search'],
    industries: ['Healthcare & Life Sciences', 'Legal, Risk & Corporate Governance'],
    bio: [
      'Anne works with organisations seeking specialist and leadership talent in regulated, expertise-driven fields.',
      'This biography is a draft placeholder and will be replaced with approved information.',
    ],
    approach: 'Combines careful technical briefing with a consultative, candidate-centred search experience.',
  },
];
